import { render, staticRenderFns } from "./forgotpassword.component.html?vue&type=template&id=e81fbe8e&scoped=true&"
import script from "./forgotpassword.component.ts?vue&type=script&lang=ts&"
export * from "./forgotpassword.component.ts?vue&type=script&lang=ts&"
import style0 from "./forgotpassword.component.vue?vue&type=style&index=0&id=e81fbe8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81fbe8e",
  null
  
)

export default component.exports